import React, { Component } from "react";
import axios from 'axios';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import ViewIcon from '@material-ui/icons/Visibility';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from "@material-ui/core/styles";
import api from '../api';

const useStyles = theme => ({
  warning: {
    color: 'orange',
  },
  danger: {
    color: 'red',
  },
});

class VehicleHistory extends React.Component {
    constructor(props) {
      super(props);
      this.state = {hansaHistory: false, loaded: false, history:{work_orders:[], maintenance_plan_tasks:[]}}
  	}

    async componentDidMount() {
    	await this.getHistory(this.props.plate)
    }

    getHistory = (plate) =>{
		const token = localStorage.getItem('userToken')
		axios.get(api.vehicles().history(plate),{ headers: {"Authorization" : `Bearer ${token}`} })
		     .then(res => {
		     		var history = this.state.history
		     		history.contract = res.data[0].contract
		     		history.description = res.data[0].version
		     		history.last_km_date = res.data[0].last_km_date
		     		history.last_km = res.data[0].last_km
		     		history.vtv_due_date = res.data[0].vtv_due_date
		     		history.warranty_due_date = res.data[0].warranty_up_to_date
		     		history.cardoc_due_date = res.data[0].cardoc_due_date
		     		history.fire_extinguisher_due_date = res.data[0].fire_extinguisher_due_date
		     		history.service_last_date = res.data[0].service_last_date
		     		history.service_last_km = parseInt(res.data[0].service_last_km)
		      		history.work_orders = res.data[0].work_orders
		     		history.authorization_matrix_id = res.data[0].authorization_matrix_id
		     		history.policy_id = res.data[0].policy_id
		     		history.maintenance_plan_tasks = res.data[0].maintenance_plan_tasks
		      		this.setState({history: history, loaded: true})
		      })
		      .catch(err =>{console.log(err)
		      })
 
    }

    getHansaHistory = () =>{
		const token = localStorage.getItem('userToken')
		axios.get(api.vehicles().hansaHistory(this.props.plate),{ headers: {"Authorization" : `Bearer ${token}`} })
		     .then(res => {
		     		var history = this.state.history
					history.work_orders = history.work_orders.concat(res.data)
					this.setState({history: history, hansaHistory: true})
		      })
		      .catch(err =>{console.log(err)
		      })
    }

    diffDays = (date) =>{
    	var diffDays = null
    	if (date){
			var today = new Date();
			date = new Date(date.split('-')[2],date.split('-')[1]-1,date.split('-')[0]);
			const diffTime = date.getTime() - today.getTime();
			diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
    	}
		return diffDays
    }

   	daysStyle = (days) => {
   		var style = ''
   		if (days){
   			if (days < 15){
   				style = 'danger'
   			} else if (days < 30) {
   				style = 'warning'
   			} 
   		}
   		return style
   	}

   	kmStyle = (km) => {
   		if (km !== 0 || km !== ''){
	   		var km_diff = parseInt(km) - parseInt(parseInt(this.state.history.service_last_km) + 10000)
	   		var style = ''
	   		if (km_diff < 250){
	   			style = 'danger'
	   		} else if (km_diff < 500){
	   			style = 'warning'
	   		}
	   		return style
   		} 
   		return ''
   	}

	render() {
		const classes = this.props.classes;
		return (
			<React.Fragment>
			{(this.state.loaded)?
					<React.Fragment>
				        <div className="ml-4" style={{marginTop: (this.props.margin || this.props.margin === undefined) ? '80px' : '0px'}}>
								<TextField
									id="name"
									label="Patente"
									value={this.props.plate}
									name="name"
									margin="normal"
									className="mr-2 mt-1"
									InputLabelProps={{
										shrink: true
									}}
									inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}}
								/>
								<TextField
									id="name"
									label="Descripción"
									value={this.state.history.description}
									name="name"
									margin="normal"
									className="mr-2 mt-1"
									InputLabelProps={{
										shrink: true
									}}
									inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}}
								/>
								<TextField
									id="name"
									type="number"
									label="Ult. km"
									value={this.state.history.last_km}
									name="name"
									margin="normal"
									className="mr-2 mt-1"
									InputLabelProps={{
										shrink: true
									}}
									inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}}
								/>
								<TextField
									id="name"
									type="date"
									label="Ult. fecha KM"
									value={this.state.history.last_km_date}
									name="name"
									margin="normal"
									className="mr-2 mt-1"
									InputLabelProps={{
										shrink: true
									}}
									inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}}
								/>
				        </div>
						<div className="row mt-1 ml-4" >
							<Button className="mt-2 mr-2" variant="contained" color="primary" size="small" style={{fontSize: '0.75rem'}} onClick={()=>window.open(api.authorization_matrix().preview(this.state.history.authorization_matrix_id), "_blank")}>Ver matriz</Button> 
							<Button className="mt-2 mr-2" variant="contained" color="primary" size="small" style={{fontSize: '0.75rem'}} onClick={()=>window.open(api.policy().preview(this.state.history.policy_id), "_blank")}>Ver politica</Button> 
							<Button className="mt-2 mr-2" variant="contained" color="primary" size="small" style={{fontSize: '0.75rem'}} onClick={()=>window.open("/services/"+this.state.history.contract.id, "_blank")}>Ver servicios contratados</Button> 

						</div>
					    <Typography variant="h6" className="ml-4">Próximos vencimientos</Typography>
				        <div className="row mt-2 ml-4" >
							<Table size="small" aria-label="a dense table" style={{width: 'auto', minWidth:'650px'}}>
						        <TableHead>
						          <TableRow>
						            <TableCell>VTV</TableCell>
						            <TableCell>Cedula Verde</TableCell>
{/*						            <TableCell>Service</TableCell>
						            <TableCell>Service (km)</TableCell>
*/}						            <TableCell>Matafuego</TableCell>
						            <TableCell>Garantía</TableCell>
						          </TableRow>
						        </TableHead>
						        <TableBody>
						        	<TableCell className={classes[this.daysStyle(this.diffDays(this.state.history.vtv_due_date))]}  style={{fontSize: '0.75rem'}}>{this.state.history.vtv_due_date}</TableCell>
						        	<TableCell className={classes[this.daysStyle(this.diffDays(this.state.history.cardoc_due_date))]}  style={{fontSize: '0.75rem'}}>{this.state.history.cardoc_due_date}</TableCell>
{/*						        	<TableCell className={classes[this.daysStyle(this.diffDays(this.state.history.service_last_date))]} style={{fontSize: '0.75rem'}}>{this.state.history.service_last_date} </TableCell>
						        	<TableCell className={classes[this.kmStyle(this.state.history.service_last_km)]} style={{fontSize: '0.75rem'}}>{this.state.history.service_last_km}</TableCell>
*/}						        	<TableCell className={classes[this.daysStyle(this.diffDays(this.state.history.fire_extinguisher_due_date))]}  style={{fontSize: '0.75rem'}}>{this.state.history.fire_extinguisher_due_date}</TableCell>
						        	<TableCell className={classes[this.daysStyle(this.diffDays(this.state.history.warranty_due_date))]} style={{fontSize: '0.75rem'}}>{this.state.history.warranty_due_date}</TableCell>
						        </TableBody>
					        </Table>					
					    </div>
					    <Typography variant="h6" className="mt-1 ml-4">Próximas tareas - Plan de mantenimiento
					      	<Button className="mt-2 ml-2" variant="contained" color="primary" size="small" style={{fontSize: '0.75rem'}} onClick={()=>window.open("/maintenance-plan/"+this.state.history.maintenance_plan_tasks[0].maintenance_plan_id+"/0", "_blank")}>Ver plan</Button> 
					    </Typography>
				        <div className="row mt-2 ml-4" >
							<Table size="small" aria-label="a dense table" style={{width: 'auto', minWidth:'650px'}}>
						        <TableHead>
						          <TableRow>
						            <TableCell>Tarea</TableCell>
						            <TableCell>KM Hasta</TableCell>
						            <TableCell>Mes Hasta</TableCell>
						            <TableCell>KM Restantes</TableCell>
						            <TableCell>Meses Restantes</TableCell>
						          </TableRow>
						        </TableHead>
						        <TableBody>
						        	{(this.state.history.maintenance_plan_tasks.map((val,idx)=>{
						        		return (
						        			<React.Fragment>
									        	<TableRow>
										        	<TableCell style={{fontSize: '0.75rem'}}>{val.task_name}</TableCell>
										        	<TableCell style={{fontSize: '0.75rem'}}>{val.up_to_km}</TableCell>
										        	<TableCell style={{fontSize: '0.75rem'}}>{val.months} </TableCell>
										        	<TableCell style={{fontSize: '0.75rem'}}>{val.remaning_km}</TableCell>
										        	<TableCell style={{fontSize: '0.75rem'}}>{val.remaining_months}</TableCell>
									        	</TableRow>
								        	</React.Fragment>
					        			)
						        	}))}
						        </TableBody>
					        </Table>
					    </div>
					      <Typography variant="h6" className="mt-1 ml-4">Últimas tareas</Typography> 
					      <div className="row mt-2 ml-4">
							<Table size="small" aria-label="a dense table" style={{width: 'auto', minWidth:'650px'}}>
						        <TableHead>
						          <TableRow>
						            <TableCell># OT</TableCell>
						            <TableCell># OT Hansa</TableCell>
						            <TableCell>Tipo de OT</TableCell>
						            <TableCell>Motivo</TableCell>
						            <TableCell>Acción</TableCell>
						            <TableCell>Tarea</TableCell>
						            <TableCell>KM</TableCell>
						            <TableCell>Fecha creacion</TableCell>
						            <TableCell>Ult. Modificación</TableCell>
						            <TableCell>Estado</TableCell>
						            <TableCell>&nbsp;</TableCell>
						          </TableRow>
						        </TableHead>
						        <TableBody>
						        	{(this.state.history.work_orders.map((val,idx)=>{

						        		return (
								            <TableRow key={idx}>
								              <TableCell style={{fontSize: '0.75rem'}} >{val.id}</TableCell>
								              <TableCell style={{fontSize: '0.75rem'}} >{val.hansa_code}</TableCell>
								              <TableCell style={{fontSize: '0.75rem'}}>{val.type}</TableCell>
								              <TableCell style={{fontSize: '0.75rem'}}>{val.reason}</TableCell>
								              <TableCell style={{fontSize: '0.75rem'}}>{val.tasks.map((task,id_task)=>{
												return (
								              		task.action.name+ ' '
							              		)
								              })}</TableCell>
								              <TableCell style={{fontSize: '0.75rem'}}>{val.tasks.map((task,id_task)=>{
												  
								              	return (
								              		(task.task) ? task.task.name+ ' ' : ''
							              		)
								              })}</TableCell>
								              <TableCell style={{fontSize: '0.75rem'}}>{val.km}</TableCell>
								              <TableCell style={{fontSize: '0.75rem'}}>{val.created_at}</TableCell>
								              <TableCell style={{fontSize: '0.75rem'}}>{val.updated_at}</TableCell>
								              <TableCell style={{fontSize: '0.75rem'}}>{val.state}</TableCell>
								              <TableCell style={{fontSize: '0.75rem'}}>
												  {(val.id)
												  ?
													  <Tooltip title="Ver OT" aria-label="ver_ot"><ViewIcon onClick={()=>window.open("/work-order/"+val.id, "_blank")}/></Tooltip>
													:
														''
													}
											  </TableCell>
								            </TableRow>

					        			)
						        	}))}
						        </TableBody>
							</Table>
						</div>
						<div className="row ml-auto">
							<Button disabled={this.state.hansaHistory} className="mt-2 mr-2" variant="contained" color="primary" size="small" style={{fontSize: '0.75rem'}} onClick={()=>this.getHansaHistory()}>Ver Historial Hansa</Button> 
					      	<Button className="mt-2" variant="contained" color="primary" size="small" style={{fontSize: '0.75rem'}} onClick={()=>window.open("/work-orders?plate="+this.props.plate, "_blank")}>Ver todas las tareas</Button> 
						</div>
					</React.Fragment>
				:
					<CircularProgress className="ml-4" style={{marginTop: '80px'}}/> 					
			}
			</React.Fragment>

		)
	}

}

export default withStyles(useStyles)(VehicleHistory);

